
import Vue from "vue";

export default Vue.extend({
	props: {
		open: {
			type: Boolean,
			required: false
		},
		showTotal: {
			type: Boolean,
			default: true
		},
		isSigned: {
			type: Boolean,
			default: false
		}
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
